<template>
  <div>
    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="data === undefined">
      <h4 class="alert-heading">
        Ошибка получения данных
      </h4>
      <div class="alert-body">
        Не удалось найти обьект с данным id. Проверьте
        <b-link
          class="alert-link"
          :to="{ name: 'user-users-list'}"
        >
          Список обьектов
        </b-link>
        список обьектов.
      </div>
    </b-alert>

    <template v-if="data">
      <!-- First Row -->

      <b-row>
        <b-col cols="12">
          <user-info-card :data="data" />
        </b-col>
        <b-col>
          <b-tabs>
            <b-tab title="Замеры" lazy>
              <measurements-list :user-active-option="data.id"></measurements-list>
            </b-tab>

            <b-tab title="Железные дороги" lazy>
              <railways-list :extra-filters="{user: data.id}"></railways-list>
            </b-tab>
            <b-tab title="Участки" lazy>
              <sectors-list :extra-filters="{user: data.id}"></sectors-list>
            </b-tab>
            <b-tab title="Станции и перегоны" lazy>
              <stations-list :extra-filters="{user: data.id}"></stations-list>
            </b-tab>
            <b-tab title="Платформы" lazy>
              <platforms-list :extra-filters="{user: data.id}"></platforms-list>
            </b-tab>
            <b-tab title="Мостовые переходы" lazy>
              <bridges-list :extra-filters="{user: data.id}"></bridges-list>
            </b-tab>
            <b-tab title="Навесы" lazy>
              <sheds-list :extra-filters="{user: data.id}"></sheds-list>
            </b-tab>
            <b-tab title="Торцевые ограждения" lazy>
              <fencings-list :extra-filters="{user: data.id}"></fencings-list>
            </b-tab>
            <b-tab title="Опоры" lazy>
              <pillars-list :extra-filters="{user: data.id}"></pillars-list>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>

  import store from '@/store'
  import { STORE_MODULE_NAME, STORE_MODULE_CONFIG}  from '../userStoreModule';

  import {ref, onBeforeMount, onBeforeUnmount, onMounted} from '@vue/composition-api'


  import router from '@/router'
  import { BCard, BCardBody, BCardTitle, BCardSubTitle, BTable, BRow, BCol, BAlert, BLink, BTabs, BTab} from 'bootstrap-vue'
  import UserInfoCard from '../components/UserInfoCard.vue'

  import useUser from '../useUser'

  // Lists
  import MeasurementsList from '@/views/apps/measurement/measurement/views/List.vue'

  // Railway structure List
  import RailwaysList from '@/views/apps/railway_structure/railway/views/List.vue'
  import SectorsList from '@/views/apps/railway_structure/sector/views/List.vue'
  import StationsList from '@/views/apps/railway_structure/station/views/List.vue'
  import PlatformsList from '@/views/apps/railway_structure/platform/views/List.vue'
  import BridgesList from '@/views/apps/railway_structure/bridge/views/List.vue'
  import ShedsList from '@/views/apps/railway_structure/shed/views/List.vue'
  import FencingsList from '@/views/apps/railway_structure/fencing/views/List.vue'
  import PillarsList from '@/views/apps/railway_structure/pillar/views/List.vue'

  export default {
    components: {
      BCard,
      BCardBody,
      BCardTitle,
      BCardSubTitle,
      BTable,
      BRow,
      BCol,
      BAlert,
      BLink,
      BTabs,
      BTab,

      // Local Components
      UserInfoCard,
      MeasurementsList,
      RailwaysList,
      SectorsList,
      StationsList,
      PlatformsList,
      BridgesList,
      ShedsList,
      FencingsList,
      PillarsList,



    },
    setup() {

      const data = ref(null)

      const {fetchDataUrl} =useUser()

      // Re-register module with additional options
      onBeforeMount(() => {

        if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, STORE_MODULE_CONFIG)
      })

        // UnRegister on leave
      onBeforeUnmount(() => {
          if (!store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
      })

      onMounted( async ()=>{
        await store.dispatch(fetchDataUrl, { id: router.currentRoute.params.id })
                .then(response => { data.value = response.data })
                .catch((err) => {})
      })

      return {
        data,
      }
    },
  }
</script>
